export default __webpack_public_path__ + "static/22-9c1303e00cd34008982f0fdca57c9e7d.webp";